"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const consts_1 = require("~/store/consts");
const consts_2 = require("~/store/account/consts");
const types_1 = require("~/store/types");
const UI_1 = require("~/components/UI");
const controls_1 = require("~/components/common/controls");
const EditProjectForm_1 = __importDefault(require("~/components/ProjectManagement/EditProjectForm"));
const isEmail_1 = __importDefault(require("~/utils/isEmail"));
const useProjectStatus_1 = __importDefault(require("~/hooks/useProjectStatus"));
const QuoteWidget_scss_1 = __importDefault(require("./QuoteWidget.scss"));
function QuoteWidget() {
    var _a, _b;
    const { t } = (0, react_i18next_1.useTranslation)('quote-widget');
    const { dispatchToggleQuote, dispatchToggleWidget, dispatchSubmitQuote, dispatchSetDisabled, dispatchGetCurrentProjectSuccess, dispatchBomSubmitDisabled, } = (0, redux_1.bindActionCreators)({
        dispatchToggleQuote: actions_1.toggleQuote,
        dispatchSubmitQuote: actions_1.submitQuote,
        dispatchSetDisabled: actions_1.setDisabled,
        dispatchGetCurrentProjectSuccess: actions_1.getCurrentProjectSuccess,
        dispatchToggleWidget: actions_1.toggleWidget,
        dispatchBomSubmitDisabled: actions_1.setBomSubmitDisabled,
    }, (0, react_redux_1.useDispatch)());
    const revisionNumber = (0, react_redux_1.useSelector)(selectors_1.selectRevisionNumber);
    const isSubmitDisabled = (0, react_redux_1.useSelector)(selectors_1.selectIsSubmitDisabled);
    const currentProject = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProject);
    const currentUserRole = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserRole);
    const isDataLoading = (0, react_redux_1.useSelector)(selectors_1.selectIsDataLoading);
    const currentUser = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const [isDisabled, setIsDisabled] = (0, react_1.useState)(true);
    const [comment, setComment] = (0, react_1.useState)('');
    const [project, setProject] = (0, react_1.useState)(null);
    const { isOrderCompleted, isProjectArchived, isProjectViewOnly } = (0, useProjectStatus_1.default)();
    const disabled = isOrderCompleted || isProjectArchived || isProjectViewOnly || isDisabled;
    const isAdmin = currentUserRole === consts_2.UserRoles.admin;
    const isDistributor = currentUserRole === consts_2.UserRoles.distributor;
    const isCustomer = currentUserRole === consts_2.UserRoles.customer;
    const submitActionHandler = (sharedWithAdmins) => {
        var _a, _b, _c;
        dispatchSetDisabled();
        const customerId = currentUserRole === consts_2.UserRoles.customer ? currentUser.id : project === null || project === void 0 ? void 0 : project.customerId;
        if ((project === null || project === void 0 ? void 0 : project.id) && (customerId || (project === null || project === void 0 ? void 0 : project.isProspect))) {
            dispatchBomSubmitDisabled(true);
            dispatchSubmitQuote({
                customerId: customerId,
                projectId: project.id,
                comment,
                projectName: project.name,
                distributorId: (_a = project.distributorId) !== null && _a !== void 0 ? _a : currentUser.distributorId,
                addressId: project.shippingAddressId || undefined,
                isDistributor: currentUserRole === consts_2.UserRoles.distributor,
                sharedWithAdmins,
                designerEmail: project.designerEmail,
                countryId: (_b = project === null || project === void 0 ? void 0 : project.countryId) !== null && _b !== void 0 ? _b : undefined,
                stateId: (_c = project === null || project === void 0 ? void 0 : project.stateId) !== null && _c !== void 0 ? _c : undefined,
            });
            dispatchToggleWidget({
                widgetName: consts_1.WIDGETS.BOM_WIDGET,
                show: false,
            });
            dispatchGetCurrentProjectSuccess(project);
        }
    };
    (0, react_1.useEffect)(() => {
        const customerId = currentUserRole === consts_2.UserRoles.customer ? currentUser.id : project === null || project === void 0 ? void 0 : project.customerId;
        if (isAdmin) {
            setIsDisabled(!((project === null || project === void 0 ? void 0 : project.id) &&
                project.name &&
                project.distributorId &&
                (customerId || (project === null || project === void 0 ? void 0 : project.isProspect)) &&
                project.designerEmail &&
                (0, isEmail_1.default)(project.designerEmail)) || isSubmitDisabled);
        }
        else if (isDistributor) {
            setIsDisabled(!((project === null || project === void 0 ? void 0 : project.id) && project.name && (customerId || (project === null || project === void 0 ? void 0 : project.isProspect))) || isSubmitDisabled);
        }
        else {
            setIsDisabled(!((project === null || project === void 0 ? void 0 : project.id) && project.name && project.distributorId && (customerId || (project === null || project === void 0 ? void 0 : project.isProspect))) ||
                isSubmitDisabled);
        }
    }, [project, isSubmitDisabled]);
    return (react_1.default.createElement(UI_1.Widget, { widgetName: consts_1.WIDGETS.BOM_WIDGET },
        react_1.default.createElement("div", { className: QuoteWidget_scss_1.default.widget },
            react_1.default.createElement("header", null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: QuoteWidget_scss_1.default.title }, t('tslots-quote')),
                    react_1.default.createElement("div", { className: QuoteWidget_scss_1.default.subtitle }, revisionNumber)),
                react_1.default.createElement("div", { className: QuoteWidget_scss_1.default.name }, t('form-name'))),
            react_1.default.createElement("main", null,
                react_1.default.createElement(EditProjectForm_1.default, { inQuoteWidget: true, onChange: setProject, project: currentProject }),
                isDataLoading === types_1.LOADING_STATE.COMPLETE ? (react_1.default.createElement("div", { className: QuoteWidget_scss_1.default.section },
                    react_1.default.createElement("div", { className: QuoteWidget_scss_1.default.inputName }, t('title.comment')),
                    react_1.default.createElement(controls_1.Textarea, { inputKey: types_1.QUOTE_FIELDS.comment, state: { value: comment, error: '' }, placeholder: t('placeholder.comment'), onInput: (key, value) => setComment(value), maxLength: 20000 }))) : null),
            react_1.default.createElement("footer", null,
                react_1.default.createElement(UI_1.Button, { onClick: () => dispatchToggleQuote(false) }, t('back')),
                isCustomer || isAdmin ? (react_1.default.createElement(UI_1.Button, { onClick: () => submitActionHandler(false), variant: "primary", disabled: disabled }, (project === null || project === void 0 ? void 0 : project.status) !== types_1.PROJECT_STATUS.IN_PROGRESS ? t('send-revision') : t('send'))) : null,
                isDistributor ? (react_1.default.createElement("div", null,
                    !((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.distributor) === null || _a === void 0 ? void 0 : _a.isDirectAccount) && (react_1.default.createElement("p", { className: QuoteWidget_scss_1.default['send-to'] }, (project === null || project === void 0 ? void 0 : project.status) !== types_1.PROJECT_STATUS.IN_PROGRESS ? t('title.send-revision-to') : t('title.send-to'))),
                    react_1.default.createElement("div", { className: QuoteWidget_scss_1.default.buttons },
                        !((_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.distributor) === null || _b === void 0 ? void 0 : _b.isDirectAccount) && (react_1.default.createElement(UI_1.Button, { onClick: () => submitActionHandler(false), variant: "primary", disabled: (project === null || project === void 0 ? void 0 : project.isProspect) || disabled }, t('title.customer'))),
                        react_1.default.createElement(UI_1.Button, { onClick: () => submitActionHandler(true), variant: "primary", disabled: disabled }, t('title.tslots'))))) : null))));
}
exports.default = QuoteWidget;
